var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageAccent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#545454",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.616 3.684a1 1 0 0 0-1.892-.018l-2.52 7.118-1.146 3.235a1 1 0 0 0 1.885.668l.91-2.57h3.466l.85 2.552a1 1 0 1 0 1.898-.632L7.988 10.8 5.616 3.684zm.036 6.434h-2.09l1.076-3.042 1.014 3.042zm12.172-1.726a1 1 0 0 1 1 1v1.373H23a1 1 0 0 1 0 2h-1.048c-.37 1.398-1.34 3.474-3.159 5.364.872.705 1.844 1.341 2.87 1.773a1 1 0 1 1-.776 1.843c-1.318-.555-2.537-1.375-3.598-2.264a14.5 14.5 0 0 1-4.326 2.291 1 1 0 0 1-.632-1.897 12.57 12.57 0 0 0 3.469-1.778c-1.047-1.073-1.834-2.104-2.266-2.768a1 1 0 0 1 1.677-1.09c.4.614 1.136 1.566 2.101 2.543 1.368-1.405 2.166-2.917 2.55-4.017h-7.215a1 1 0 0 1 0-2h4.177V9.392a1 1 0 0 1 1-1z",
    fill: "{fill}"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageAccent);
export default __webpack_public_path__ + "static/media/language_accent.640aa4baceab078852a089cb7dc930f8.svg";
export { ForwardRef as ReactComponent };